"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FLOATING_POINT_ACCURACY = exports.numberToUSD = void 0;
exports.clipFloatingPoint = clipFloatingPoint;
const numberToUSD = amount => {
  const amountStr = amount.toString();
  return Number(amount) < 0 ? `-$${Math.abs(parseFloat(amountStr)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}` : `$${parseFloat(amountStr).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
};
exports.numberToUSD = numberToUSD;
exports.FLOATING_POINT_ACCURACY = 3;
function clipFloatingPoint(num) {
  return +num.toFixed(exports.FLOATING_POINT_ACCURACY);
}